class VwGnlKurumTarifeDTO {
  id?: number = 0;
  fkGnlKurumId?: number = null;
  fkHbsUcretTarifetanimId?: number = null;
  aktif?: string = "E";
  aktifBool?: boolean = false;
  baslangictarih?: string = null;
  bitistarih?: string = null;
  maxindirimoran?: number = 0;
  ekleyenKullanici?: number = null;
  eklemeTarihi?: string = null;
  guncelleyenKullanici?: number = null;
  guncellemeTarihi?: string = null;
  varsayilan?: string = "H";
  varsayilanBool?: boolean = false;
  adi?: string = "";
  aciklama?: string = "";
  katsayi?: number = null;
  fkGnlOrganizasyonId?: number = null;
  sozlesmeNo?: string = "";
  fkKdvdurum?: number = null;
  ucrethastakarsilar?: string = "H";
  ucrethastakarsilarBool?: boolean = false;
  fkSozlesmeTuru?: number = null;
  ihaleNo?: string = "";
  puantoplam?: number = null;
  puanuyarioran?: number = null;
  huvKatsayi?: number = null;
  tarifeTipi?: number = null;
}
export default VwGnlKurumTarifeDTO;